import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.scss';

const InputWrapper = props => {
  const {
    hint,
    label,
    disabled,
    children,
    required,
    showError,
    labelNote,
    errorMessage,
  } = props;

  const labelText = required ? `${label}*` : label;

  return (
    <div
      className={classnames('c-input-holder', {
        'error': showError,
        disabled,
      })}
    >
      {label && (
        <ul className="c-input-label-holder">
          <li>
            <span>{labelText}</span>
            {hint && (
              <div className="hint-holder">
                <i className="icon icon-question-mark" />
                <div className="hint-tooltip">
                  {hint}
                </div>
              </div>
            )}
          </li>
          {labelNote && (
            <li>
              {labelNote}
            </li>
          )}
        </ul>
      )}
      <div className="c-input-element-holder">
        {children}
      </div>
      {showError && (
        <div className="error-message-holder">
          {errorMessage}
        </div>
      )}
    </div>
  )
};

InputWrapper.propTypes = {
  hint: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.any,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  showError: PropTypes.bool,
  labelNote: PropTypes.any,
  errorMessage: PropTypes.any,
};

export default InputWrapper;
